// @flow

// Get from rest endpoint.
export function get (endpoint: string) {
  return new Promise(async (resolve, reject) => {
    try {
      const request = await fetch(`${process.env.REACT_APP_API_REST_BASE}/${endpoint}`)

      if (!request.ok) {
        const requestJson = await request.json()
        const { error } = requestJson
        if (error && error.code) {
          throw new Error(error.code)
        }

        const errorResponse = requestJson        
        if (errorResponse && errorResponse.code) {
          throw new Error(errorResponse.code)
        }
        
        // Codigo no deberia de llegar aca, pero por si acaso mandemos un codigo X
        throw new Error('unknown');
      }

      const response = await request.json()
      resolve(response)
    } catch (err) {
      if (!err.message || err.message === 'Network request failed') {
        return reject(new Error('w-0-0-0').message)
      }

      reject(err.message)
    }
  })
}

// Post to a rest endpoint.
export function post (endpoint: string, data: Object) {
  return new Promise(async (resolve, reject) => {
    try {
      const request = await fetch(endpoint, {
        method: 'POST',
        mode: 'cors',
        body: JSON.stringify(data)
      })

      if (!request.ok) {
        const requestJson = await request.json()
        const { error } = requestJson
        if (error && error.code) {
          throw new Error(error.code)
        }

        const errorResponse = requestJson
        if (errorResponse && errorResponse.code) {
          throw new Error(errorResponse.code)
        }
        
        // Codigo no deberia de llegar aca, pero por si acaso mandemos un codigo X
        throw new Error('unknown');
      }

      const response = await request.json()
      resolve(response)
    } catch (err) {
      if (!err.message || err.message === 'Network request failed') {
        return reject(new Error('w-0-0-0').message)
      }

      reject(err.message)
    }
  })
}



// WEBPACK FOOTER //
// ./src/services/utils.js